const releaseNotes = [
  [
    'October 2018',
    [
      'Rounding inconsistencies across analysis views and PPT output are now fixed',
      'Several minor New Customer DSA bug fixes'
    ]
  ],
  [
    'September 2018',
    [
      'New Customer DSA tool is released!',
      'Opportunity linking enhancements'
    ]
  ],
  [
    'August 2018',
    [
      'Renamed to Splunk Value Platform',
      'Added ability to convert a New Customer DSA to a full DSA',
      'Numerous minor improvements to the New Customer DSA',
      'Multiple DSA PPT improvements including Security Extension slides',
      'New Overview slide for the New Customer DSA PPT'
    ]
  ],
  [
    'July 2018',
    [
      [
        'New Customer DSA is released! Allows users to create simplified DSAs for prospective customers not yet using Splunk',
        [
          'Removal of indexing, usage and value realized inputs',
          'New analyses and PPT optimized for new customers'
        ]
      ]
    ]
  ],
  [
    'June 2018',
    [
      'Required Salesforce Opportunity linking for assessments being created for customers'
    ]
  ],
  [
    'May 2018',
    [
      [
        'Training Assessment and Customer Assessment feature added:',
        [
          'Training Assessments for onboarding/training new Splunk Value Platform users',
          'Customer Assessments for real customer assessments, which must be linked to the related Opportunity'
        ],
        'Minor enhancements & bugfixes'
      ]
    ]
  ],
  [
    'April 2018',
    [
      'New Overview PPT slide and minor PPT visual improvements',
      'Account Seach upgraded to include New Prospect/Customer Accounts from Salesforce'
    ]
  ],
  [
    'March 2018',
    [
      'Minor enhancements & bugfixes'
    ]
  ],
  [
    'February 2018',
    [
      [
        'Security Extension is released for the DSA!',
        [
          'Allows identification of security correlations critical to the customer',
          'Includes new security analysis and PPT output'
        ]
      ]
    ]
  ],
  [
    'October 2017',
    [
      'PPT Output formatting improvements'
    ]
  ],
  [
    'September 2017',
    [
      [
        'DSA tool is released!',
        [
          'First of the BVC tools to be released to provide Data Source Assessment capability'
        ]
      ]
    ]
  ]
];

export default releaseNotes;



// WEBPACK FOOTER //
// ./src/constants/releaseNotes.js